import Cookies from 'js-cookie';

(function ($, window) {
  $.fn.TimedPopup = function (options) {
    return this.each(function () {
      var settings = $.extend({
        cookieValue: 'sent-away',
        expires: 7,
        cookieNameAttr: 'data-timed-popup',
        closeSelector: '[data-timed-popup-close]',
        delaySelector: 'data-timed-popup-delay',
        delay: 0,
      }, options);

      var $popup = $(this);
      var cookieName = $popup.attr(settings.cookieNameAttr);
      var cookieVal = Cookies.get(cookieName);
      settings.delay = $popup.attr(settings.delaySelector);
      $popup.addClass('timed-popup__ready');

      if (!cookieVal || cookieVal !== settings.cookieValue || options) {
        window.setTimeout(function () {
          window.setTimeout(function () {
            $popup.addClass('timed-popup__visible');
          }, 500);
        }, settings.delay);
      }

      $popup.find(settings.closeSelector).on('click', function () {
        Cookies.set(cookieName, settings.cookieValue, { expires: settings.expires });
        $popup.removeClass('timed-popup__visible');
      });
    });
  }
})(jQuery, window);
